// extracted by mini-css-extract-plugin
export default {"wrapper":"StretchToCardEdge_wrapper__giTs+"};